import React from 'react'
import { FlexView } from './components/common'
import Header from './containers/layout/Header'
import Home from './pages/Home'
import Login from './pages/Login'
import JobDetails from './pages/JobDetails'
import JobUpload from './pages/jobUpload'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import PrivateRoute from './containers/router/PrivateRoute'

const Router = () => {

  return (
    <FlexView width="100%" minHeight="100vh">
      <BrowserRouter>
        <Header />
        <Switch>
          <PrivateRoute exact path='/'>
            <PrivateRoute exact path='/'>
              <Home />
            </PrivateRoute>
          </PrivateRoute>
          <PrivateRoute path='/job-details/:jobId'>
            <PrivateRoute path='/job-details/:jobId'>
              <JobDetails />
            </PrivateRoute>
          </PrivateRoute>
          <PrivateRoute path='/job-upload'>
            <PrivateRoute path='/job-upload'>
              <JobUpload />
            </PrivateRoute>
          </PrivateRoute>
          <Route path='/login'>
            <Login />
          </Route>
        </Switch>
      </BrowserRouter>
    </FlexView>
  )
}

export default Router